import { api } from './api';
import { MailMessage, SendMailRequest, MailListResponse, MailStatus } from '../types/mail';
import { PaginatedResponse } from '../types/pagination';
import { toMailMessage } from '../utils/mailMapper';

export const mailApi = {
  /**
   * Отправить письмо с документом
   */
  sendMail: async (request: SendMailRequest): Promise<MailMessage> => {
    console.log('[MailAPI] Отправка письма:', request);
    const response = await api.post('/mail/send', request);
    console.log('[MailAPI] Ответ на отправку письма:', response.data);
    return response.data;
  },

  /**
   * @deprecated Используйте getIncomingMails или getOutgoingMails
   */
  getMyMail: async (page: number, pageSize: number): Promise<MailListResponse> => {
    console.log(`[MailAPI] Получение списка писем... Page: ${page}, PageSize: ${pageSize}`);
    const response = await api.get('/mail', {
      params: {
        page,
        pageSize
      }
    });
    console.log('[MailAPI] Ответ на получение писем:', response.data);
    return response.data;
  },

  /**
   * Получить входящие письма пользователя (с пагинацией)
   */
  getIncomingMails: async (page: number, pageSize: number): Promise<PaginatedResponse<MailMessage>> => {
    const response = await api.get('/mail/incoming', { params: { pageNumber: page, pageSize } });
    const data = response.data;
    return {
      ...data,
      items: data.items.map((item: any) => toMailMessage(item))
    };
  },

  /**
   * Получить исходящие письма пользователя (с пагинацией)
   */
  getOutgoingMails: async (page: number, pageSize: number): Promise<PaginatedResponse<MailMessage>> => {
    const response = await api.get('/mail/outgoing', { params: { pageNumber: page, pageSize } });
    const data = response.data;
    return {
      ...data,
      items: data.items.map((item: any) => toMailMessage(item))
    };
  },

  /**
   * Принять письмо (добавить документ в базу знаний)
   */
  acceptMail: async (mailId: string): Promise<void> => {
    console.log('[MailAPI] Принятие письма:', mailId);
    const response = await api.post(`/mail/${mailId}/accept`);
    console.log('[MailAPI] Ответ на принятие письма:', response.data);
    return response.data;
  },

  /**
   * Отклонить письмо
   */
  rejectMail: async (mailId: string): Promise<void> => {
    console.log('[MailAPI] Отклонение письма:', mailId);
    const response = await api.post(`/mail/${mailId}/decline`);
    console.log('[MailAPI] Ответ на отклонение письма:', response.data);
    return response.data;
  },

  /**
   * Получить количество непрочитанных писем
   */
  getUnreadCount: async (): Promise<{ count: number }> => {
    console.log('[MailAPI] Получение количества непрочитанных писем...');
    const response = await api.get('/mail/unread-count');
    console.log('[MailAPI] Ответ на получение количества непрочитанных:', response.data);
    return response.data;
  }
}; 